var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "11px",
    viewBox: "0 0 12 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sprint-7",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.-listing",
    transform: "translate(-297.000000, -311.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(291.000000, 306.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9293721,13.2655904 L12.5528417,5.57540121 C12.3525717,5.2124868 11.9774405,5 11.5397874,5 C11.1021344,5 10.7397077,5.2124743 10.5267332,5.57540121 L6.15020252,13.2655904 C5.94993249,13.6280171 5.94993249,14.0656701 6.15020252,14.428597 C6.35047256,14.7910238 6.72560398,15.003998 7.15055258,15.003998 L15.8908589,15.003998 C16.3158075,15.003998 16.6909387,14.791524 16.8912087,14.428597 C17.1290794,14.0656826 17.1290794,13.6280296 16.9293083,13.2655904 L16.9293721,13.2655904 Z M12.1777105,13.1776696 L11.0147038,13.1776696 L11.0147038,12.1646154 L12.1777105,12.1646154 L12.1777105,13.1776696 Z M12.1777105,11.577485 L11.0147038,11.577485 L11.0147038,8.67609548 L12.1777105,8.67609548 L12.1777105,11.577485 Z",
    id: "Fill-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallWarning);
export default __webpack_public_path__ + "static/media/small-warning.a088b571578a77b2b2323aab1405e37f.svg";
export { ForwardRef as ReactComponent };